
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-0.75 -0.75 24 24","stroke-width":"1.5","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('love-heart-hold')]),_c('path',{attrs:{"d":"m6.552 10.674 -1.688 -1.781a4.945 4.945 0 0 1 -0.863 -5.538h0a4.515 4.515 0 0 1 7.383 -1.246L12.656 3.433l1.272 -1.324a4.515 4.515 0 0 1 7.382 1.246h0a4.945 4.945 0 0 1 -0.863 5.538L12.656 16.875l-1.949 -1.998","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m7.031 14.063 1.568 -1.177a1.471 1.471 0 0 1 2.107 0.361h0a1.471 1.471 0 0 1 0 1.631l-1.542 2.313A4.219 4.219 0 0 1 7.219 18.768L4.922 19.688v2.109","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M5.872 9.955C-0.294 12.598 0.703 18.268 0.703 21.797","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    